import { useState } from "react";

// campo "vivo": etichetta che sale, riga che si accende in cotto al focus
export const Field = ({
    id,
    label,
    value,
    onChange,
    type = "text",
    required = false,
    multiline = false,
    testId,
    autoComplete,
    name,
}) => {
    const [focus, setFocus] = useState(false);
    const lifted = focus || value.length > 0;
    const Tag = multiline ? "textarea" : "input";
    return (
        <div className={`fld ${lifted ? "lifted" : ""} ${focus ? "focus" : ""}`}>
            <Tag
                id={id}
                name={name}
                type={multiline ? undefined : type}
                rows={multiline ? 3 : undefined}
                required={required}
                value={value}
                autoComplete={autoComplete}
                onChange={(e) => onChange(e.target.value)}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                data-testid={testId}
                aria-required={required || undefined}
            />
            <label htmlFor={id}>
                {label}
                {required && <span className="fld-req" aria-hidden="true"> *</span>}
            </label>
            <span className="fld-line" aria-hidden="true" />
        </div>
    );
};
